import { call, put, takeLatest } from 'redux-saga/effects';
import { apiResource } from '../services/api';
import reducerConstant from 'common/reducerConstants';
import apiConstant from 'common/apiConstants';
import {
  getProjectSuccess,
  getProjectFailed,
  getProjectByIdSuccess,
  getProjectByIdFailed,
  getProjectMilestoneSuccess,
  getProjectMilestoneFailed,
} from '../actions/projectActions';

export function* getProjects() {
  try {
    const res = yield call(apiResource.get, apiConstant.projects);
    if (res.success) {
      yield put(
        getProjectSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        getProjectFailed({
          message: res.data.message,
        })
      );
    }
  } catch (e) {
    yield put(
      getProjectFailed({
        message: 'Something went wrong',
      })
    );
  }
}
function* getProjectById(dObj) {
  try {
    const res = yield call(
      apiResource.get,
      apiConstant.projectsById(dObj.payload.id, true, true, 1)
    );
    if (res.success) {
      yield put(
        getProjectByIdSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        getProjectByIdFailed({
          message: res.data.message,
          errors: res.data.errors,
        })
      );
    }
  } catch (e) {
    yield put(
      getProjectByIdFailed({
        message: 'Something went wrong',
      })
    );
  }
}
function* getProjectMilestone(dObj) {
  try {
    const res = yield call(
      apiResource.get,
      apiConstant.getMilestone(
        dObj.payload.id,
        dObj.payload.status,
        dObj.payload.search,
        dObj.payload.page
      )
    );
    if (res.success) {
      yield put(
        getProjectMilestoneSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        getProjectMilestoneFailed({
          message: res.data.message,
          errors: res.data.errors,
        })
      );
    }
  } catch (e) {
    yield put(
      getProjectMilestoneFailed({
        message: 'Something went wrong',
      })
    );
  }
}

function* projectSaga() {
  yield takeLatest(reducerConstant.getProject, getProjects);
  yield takeLatest(reducerConstant.getProjectById, getProjectById);
  yield takeLatest(reducerConstant.getProjectMilestone, getProjectMilestone);
}

export default projectSaga;
